module.exports = __webpack_public_path__ + "static/img/fa1.d3267020.png";